import { combineReducers } from "redux";
import userAuthReducer from "./userAuthReducer";
import promoteursReducer from "./promoteursReducer";
import immobilierReducer from "./immobilierReducer";
import displayHonorairesReducer from "./honorairesReducer";
import modalReducer from "./modalReducer";
import enregistresReducer from "./enregistresReducer";
import userListReducer from "./userListReducer";

const rootReducer = combineReducers({
  userAuthReducer,
  promoteursReducer,
  immobilierReducer,
  displayHonorairesReducer,
  modalReducer,
  enregistresReducer,
  userListReducer,
});

export default rootReducer;
